import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import ReactMarkdown from 'react-markdown';

import Link from './Link';
import Block from './Block';

const propTypes = {
    pages: PropTypes.array.isRequired,
    pathname: PropTypes.string,
};

const defaultProps = {
    pages: [],
    pathname: null,
};

class Subpages extends Component {

    constructor(props) {
        super(props);
        this.renderPage = this.renderPage.bind(this);
    }

    // eslint-disable-next-line class-methods-use-this
    renderPage(page) {
        if (page.type === 'news') {
            return this.renderNews(page);
        }
        const className = classNames({
            icon: true,
            [page.icon]: true,
            colored: true,
        });

        return (
            <div key={`page_link_${page.id}`} className="subpage">
                <Link to={page.pathname} className="subpage-link">
                    <strong className="title font-inline"><span className={className} />{page.title}</strong>
                    { !isEmpty(page.summary) ? (
                        <span className="text">
                            <ReactMarkdown source={page.summary} />
                        </span>
                    ) : null }
                </Link>
            </div>
        );
    }

    // eslint-disable-next-line class-methods-use-this
    renderNews(page) {
        const { pathname } = this.props;
        const url = !isEmpty(pathname) ? `${pathname.replace(/\/$/, '')}/${page.slug}` : page.pathname;
        return (
            <div key={`page_link_${page.id}`} className="subpage subpage-news">
                <Link to={url} className="subpage-link">
                    <span className="news-date"><span>{ moment(page.created_at).format('D MMMM YYYY') }</span></span>
                    <strong className="title">{page.title}</strong>
                </Link>
                { !isEmpty(page.summary) ? (
                    <div className="text">
                        <ReactMarkdown source={page.summary} />
                    </div>
                ) : null }
                { !isEmpty(page.blocks) ? (
                    <Block
                        blocks={(page.blocks || []).map(block => ({
                            ...block,
                            rounded: false,
                            border: false,
                        }))}
                    />
                ) : null }
            </div>
        );
    }

    render() {
        const { pages } = this.props;

        return (
            <div className="partial partial-subpages">
                { pages.map(this.renderPage) }
            </div>
        );
    }
}

Subpages.propTypes = propTypes;
Subpages.defaultProps = defaultProps;

export default Subpages;



// WEBPACK FOOTER //
// ./components/partials/Subpages.jsx